(function () {
  'use strict';

  /* =======================================================
     Prevent global boot duplication
     ======================================================= */

  if (window.BorrStableSlideshowBooted) {
    return;
  }

  window.BorrStableSlideshowBooted = true;


  /* =======================================================
     Slider
     ======================================================= */

  class BorrStableSlideshow {
    constructor(root) {
      if (!root || root.dataset.sliderInitialized === 'true') {
        return;
      }

      root.dataset.sliderInitialized = 'true';

      this.root = root;

      this.track = root.querySelector('[data-slider-track]');
      this.viewport = root.querySelector('[data-slider-viewport]');

      this.slides = Array.from(
        root.querySelectorAll('[data-slider-slide]')
      );

      this.prevButton = root.querySelector('[data-slider-prev]');
      this.nextButton = root.querySelector('[data-slider-next]');

      this.dots = Array.from(
        root.querySelectorAll('[data-slider-dot]')
      );

      this.counter = root.querySelector('[data-slider-current]');

      this.currentIndex = 0;

      this.autoplayEnabled =
        root.dataset.autoplay === 'true';

      this.pauseOnHover =
        root.dataset.pauseOnHover === 'true';

      this.autoplaySpeed =
        parseInt(root.dataset.autoplaySpeed, 10) || 5000;

      this.autoplayTimer = null;

      this.isHovered = false;

      this.touchStartX = 0;
      this.touchStartY = 0;

      this.touchEndX = 0;
      this.touchEndY = 0;

      this.lastSwipeTime = 0;

      this.swipeThreshold = 45;

      this.init();
    }


    /* =====================================================
       INIT
       ===================================================== */

    init() {
      if (!this.track || this.slides.length === 0) {
        return;
      }

      this.bindNavigation();
      this.bindPagination();
      this.bindSwipe();
      this.bindVisibility();

      if (this.pauseOnHover) {
        this.bindHover();
      }

      this.bindLinkProtection();

      this.showSlide(0, false);

      this.startAutoplay();
    }


    /* =====================================================
       SHOW SLIDE
       ===================================================== */

    showSlide(index, restartAutoplay = true) {
      const slideCount = this.slides.length;

      if (slideCount === 0) {
        return;
      }

      if (index < 0) {
        index = slideCount - 1;
      }

      if (index >= slideCount) {
        index = 0;
      }

      this.currentIndex = index;

      this.slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === index;

        slide.classList.toggle(
          'is-active',
          isActive
        );

        slide.setAttribute(
          'aria-hidden',
          isActive ? 'false' : 'true'
        );
      });

      this.updatePagination();

      if (restartAutoplay) {
        this.restartAutoplay();
      }
    }


    /* =====================================================
       NEXT / PREVIOUS
       ===================================================== */

    next() {
      this.showSlide(
        this.currentIndex + 1
      );
    }

    previous() {
      this.showSlide(
        this.currentIndex - 1
      );
    }


    /* =====================================================
       PAGINATION
       ===================================================== */

    updatePagination() {
      if (this.counter) {
        this.counter.textContent =
          String(this.currentIndex + 1);
      }

      if (this.dots.length) {
        this.dots.forEach((dot, index) => {
          dot.setAttribute(
            'aria-selected',
            index === this.currentIndex
              ? 'true'
              : 'false'
          );
        });
      }
    }


    /* =====================================================
       ARROWS
       ===================================================== */

    bindNavigation() {
      if (this.prevButton) {
        this.prevButton.addEventListener(
          'click',
          () => {
            this.previous();
          }
        );
      }

      if (this.nextButton) {
        this.nextButton.addEventListener(
          'click',
          () => {
            this.next();
          }
        );
      }
    }


    /* =====================================================
       DOTS
       ===================================================== */

    bindPagination() {
      this.dots.forEach((dot) => {
        dot.addEventListener(
          'click',
          () => {
            const index =
              parseInt(
                dot.dataset.slideTarget,
                10
              );

            if (Number.isNaN(index)) {
              return;
            }

            this.showSlide(index);
          }
        );
      });
    }


    /* =====================================================
       AUTOPLAY
       ===================================================== */

    startAutoplay() {
      if (
        !this.autoplayEnabled ||
        this.slides.length <= 1 ||
        document.hidden ||
        this.isHovered
      ) {
        return;
      }

      this.stopAutoplay();

      this.autoplayTimer = window.setInterval(
        () => {
          this.showSlide(
            this.currentIndex + 1,
            false
          );
        },
        this.autoplaySpeed
      );
    }

    stopAutoplay() {
      if (!this.autoplayTimer) {
        return;
      }

      window.clearInterval(
        this.autoplayTimer
      );

      this.autoplayTimer = null;
    }

    restartAutoplay() {
      if (!this.autoplayEnabled) {
        return;
      }

      this.stopAutoplay();
      this.startAutoplay();
    }


    /* =====================================================
       PAGE VISIBILITY
       ===================================================== */

    bindVisibility() {
      document.addEventListener(
        'visibilitychange',
        () => {
          if (document.hidden) {
            this.stopAutoplay();
          } else {
            this.startAutoplay();
          }
        }
      );
    }


    /* =====================================================
       OPTIONAL HOVER PAUSE
       ===================================================== */

    bindHover() {
      this.root.addEventListener(
        'mouseenter',
        () => {
          this.isHovered = true;
          this.stopAutoplay();
        }
      );

      this.root.addEventListener(
        'mouseleave',
        () => {
          this.isHovered = false;
          this.startAutoplay();
        }
      );
    }


    /* =====================================================
       MOBILE SWIPE
       ===================================================== */

    bindSwipe() {
      this.track.addEventListener(
        'touchstart',
        (event) => {
          if (!event.changedTouches.length) {
            return;
          }

          const touch =
            event.changedTouches[0];

          this.touchStartX =
            touch.clientX;

          this.touchStartY =
            touch.clientY;
        },
        {
          passive: true
        }
      );


      this.track.addEventListener(
        'touchend',
        (event) => {
          if (!event.changedTouches.length) {
            return;
          }

          const touch =
            event.changedTouches[0];

          this.touchEndX =
            touch.clientX;

          this.touchEndY =
            touch.clientY;


          const diffX =
            this.touchStartX -
            this.touchEndX;

          const diffY =
            this.touchStartY -
            this.touchEndY;


          /*
           * Vertical scroll daha baskınsa
           * slider müdahale etmez.
           */

          if (
            Math.abs(diffY) >
            Math.abs(diffX)
          ) {
            return;
          }


          /*
           * Çok kısa hareketleri swipe
           * olarak kabul etme.
           */

          if (
            Math.abs(diffX) <
            this.swipeThreshold
          ) {
            return;
          }


          this.lastSwipeTime =
            Date.now();


          if (diffX > 0) {
            this.next();
          } else {
            this.previous();
          }
        },
        {
          passive: true
        }
      );
    }


    /* =====================================================
       PREVENT LINK CLICK AFTER SWIPE
       ===================================================== */

    bindLinkProtection() {
      this.root.addEventListener(
        'click',
        (event) => {
          const timeSinceSwipe =
            Date.now() -
            this.lastSwipeTime;

          if (timeSinceSwipe < 350) {
            const link =
              event.target.closest('a');

            if (link) {
              event.preventDefault();
              event.stopPropagation();
            }
          }
        },
        true
      );
    }


    /* =====================================================
       THEME EDITOR BLOCK SELECTION
       ===================================================== */

    selectBlock(blockId) {
      const slideIndex =
        this.slides.findIndex(
          (slide) =>
            slide.dataset.blockId ===
            blockId
        );

      if (slideIndex === -1) {
        return;
      }

      this.showSlide(
        slideIndex,
        false
      );
    }
  }


  /* =======================================================
     INITIALIZER
     ======================================================= */

  function initializeSliders(scope = document) {
    const sliders =
      scope.matches &&
      scope.matches('[data-borr-slider]')
        ? [scope]
        : Array.from(
            scope.querySelectorAll(
              '[data-borr-slider]'
            )
          );

    sliders.forEach((slider) => {
      if (
        slider.dataset.sliderInitialized ===
        'true'
      ) {
        return;
      }

      const instance =
        new BorrStableSlideshow(
          slider
        );

      slider._borrSlider =
        instance;
    });
  }


  /* =======================================================
     NORMAL PAGE LOAD
     ======================================================= */

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        initializeSliders();
      }
    );
  } else {
    initializeSliders();
  }


  /* =======================================================
     SHOPIFY THEME EDITOR
     ======================================================= */

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initializeSliders(
        event.target
      );
    }
  );


  document.addEventListener(
    'shopify:block:select',
    (event) => {
      const block =
        event.target.closest(
          '[data-slider-slide]'
        );

      if (!block) {
        return;
      }

      const slider =
        block.closest(
          '[data-borr-slider]'
        );

      if (
        !slider ||
        !slider._borrSlider
      ) {
        return;
      }

      slider._borrSlider.selectBlock(
        event.detail.blockId
      );
    }
  );
})();